import { BaseMenu } from './__internal__';
import { jsx as _jsx } from "react/jsx-runtime";
export const Menu = props => {
  return /*#__PURE__*/_jsx(BaseMenu, {
    ...props
  });
};
export const deleteItem = (sections, location) => {
  let targetSections;
  let lastItem;
  const length = location.length;
  for (let i = 0; i < length; i++) {
    const index = location[i];
    const sectionIndex = index[0];
    const itemIndex = index[1];
    targetSections = targetSections ? targetSections : sections;
    const section = targetSections[sectionIndex];
    const items = section?.items;
    const item = items[itemIndex];
    if (i === length - 1) {
      // delete data
      section.items = items.slice(0, itemIndex).concat(items.slice(itemIndex + 1));
      // there is no item in the section, and the section should be deleted
      if (section.items.length === 0) {
        targetSections = targetSections.slice(0, sectionIndex).concat(targetSections.slice(sectionIndex + 1));
        if (lastItem) lastItem.subSections = targetSections;else sections = targetSections;
      }
      break;
    } else {
      targetSections = item.subSections;
      lastItem = item;
    }
  }

  // Since sections is a complext data type, we need to change memory address to rerender the menu.
  return sections.slice(0, sections.length);
};
//# sourceMappingURL=Menu.js.map